import React, { useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useApiError, useCommercialApi } from 'Hooks';
import { Footer, Form, Input, Main, ScrollContainer, Spinner, TitleActionBar, } from 'Components/utility';
import i18n from 'Utilities/i18n';
const initialValues = {
    code: '',
    birthYear: '',
};
const MAX_LENGTH_CODE = 7;
const apiResponseErrorCode = {
    CODE_NOT_FOUND: 57,
    INCORRECT_YOB: 56,
};
const CommercialApiAddConnection = () => {
    const [loading, setLoading] = useState(false);
    const { sharingCodeValidate } = useCommercialApi();
    const { showApiErrorModal } = useApiError();
    const validationSchema = Yup.object().shape({
        code: Yup.string()
            .required(i18n.t('AddConnection.content.connectionFormFields.formField.code.errors.required'))
            .min(MAX_LENGTH_CODE, ''),
        birthYear: Yup.string()
            .required(i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.errors.required'))
            .min(4, ''),
    });
    const onSubmit = async (values) => {
        try {
            setLoading(true);
            await sharingCodeValidate(values.code, Number(values.birthYear));
        }
        catch (err) {
            const error = err;
            const errCode = error?.response?.data?.code;
            switch (errCode) {
                case apiResponseErrorCode.CODE_NOT_FOUND:
                    setFieldError('code', i18n.t('AddConnection.content.connectionFormFields.formField.code.errors.codeErrorMsg'));
                    break;
                case apiResponseErrorCode.INCORRECT_YOB:
                    setFieldError('birthYear', i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.errors.birthyearDoesNotMatch'));
                    break;
                default:
                    showApiErrorModal();
            }
        }
        finally {
            setLoading(false);
        }
    };
    const { handleSubmit, handleChange, handleBlur, setFieldError, isValid, errors, touched, values, } = useFormik({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnBlur: true,
    });
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "AddConnection", title: i18n.t('AddConnection.title') }),
        loading && React.createElement(Spinner, { testID: "Login" }),
        React.createElement(ScrollContainer, { marginTop: 0 },
            React.createElement(Form, null,
                React.createElement(Text, { testID: "AddConnection.subtitle", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", marginBottom: "$2" }, i18n.t('AddConnection.subtitle')),
                React.createElement(Stack, null,
                    React.createElement(Input, { "aria-label": i18n.t('AddConnection.content.connectionFormFields.formField.code.label'), placeholder: i18n.t('AddConnection.content.connectionFormFields.formField.code.placeholder'), label: i18n.t('AddConnection.content.connectionFormFields.formField.code.label'), testID: "code", inputMode: "text", errorMessage: errors.code, isInvalid: errors.code && touched.code ? true : false, value: values.code, onChangeText: handleChange('code'), onBlur: handleBlur('code'), maxLength: MAX_LENGTH_CODE }),
                    React.createElement(Text, { testID: "AddConnection.formField.helpText", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", color: "$text.60", marginTop: "$2", marginBottom: "$3" }, i18n.t('AddConnection.content.connectionFormFields.formField.code.helpText.uniqueCode')),
                    React.createElement(Input, { "aria-label": i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.label'), placeholder: i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.placeholder'), label: i18n.t('AddConnection.content.connectionFormFields.formField.verifyBirthYear.label'), testID: "birthYear", errorMessage: errors.birthYear, isInvalid: errors.birthYear && touched.birthYear ? true : false, value: values.birthYear, onChangeText: (e) => {
                            const handler = handleChange('birthYear');
                            return handler(e.replace(/[^0-9]/g, ''));
                        }, onBlur: handleBlur('birthYear'), inputMode: "numeric", maxLength: 4 })))),
        React.createElement(Footer, { buttonText: i18n.t('Global.microcopy.common.next'), onButtonSubmit: handleSubmit, testIDButton: "AddConnection.inviteConnection-btn", isButtonDisabled: !values.code || !values.birthYear || !isValid })));
};
export default CommercialApiAddConnection;
